import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowUp, ArrowDown, Trash2, Plus, ShieldCheck, LogOut, Loader2, Edit3, GripVertical } from 'lucide-react';
import { adminApi, logoutAdmin } from './adminApi';
import { toAssetUrl } from '@/data/runtimeApi';

const toUrl = toAssetUrl;

export default function AdminServicios() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [newSlug, setNewSlug] = useState('');
  const [newName, setNewName] = useState('');
  const [creating, setCreating] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.get('/servicios');
      setItems(data.items || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const move = async (idx, dir) => {
    const to = idx + dir;
    if (to < 0 || to >= items.length) return;
    const arr = [...items];
    [arr[idx], arr[to]] = [arr[to], arr[idx]];
    setItems(arr);
    await adminApi.post('/servicios/reorder', arr.map((x) => x.id));
  };

  const del = async (item) => {
    const msg = `¿Eliminar el servicio "${item.name}"?\n\n⚠️  ATENCIÓN: los proyectos que tengan esta categoría dejarán de mostrar su nombre de servicio en el sitio público. La URL /servicios/${item.slug} devolverá 404.\n\n¿Continuar?`;
    if (!window.confirm(msg)) return;
    await adminApi.delete(`/servicios/${item.id}`);
    load();
  };

  const create = async () => {
    if (!newSlug.trim() || !newName.trim()) { alert('Nombre y slug son obligatorios'); return; }
    setCreating(true);
    try {
      await adminApi.post('/servicios', { slug: newSlug.trim(), name: newName.trim() });
      setNewSlug(''); setNewName(''); setShowCreate(false);
      load();
    } catch (e) {
      alert(e?.response?.data?.detail || 'Error al crear');
    } finally { setCreating(false); }
  };

  const onLogout = () => { logoutAdmin(); window.location.href = '/admin/login'; };

  return (
    <div className="min-h-screen bg-[#f4f5f7]" data-testid="admin-servicios-page">
      <header className="bg-white border-b border-[#58677A]/10 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/admin" className="text-[#58677A] hover:text-[#ED6B24] transition"><ArrowLeft size={18}/></Link>
            <div className="w-9 h-9 rounded-lg bg-[#ED6B24]/10 flex items-center justify-center"><ShieldCheck className="text-[#ED6B24]" size={18} /></div>
            <div>
              <p className="text-[15px] font-bold text-[#58677A] leading-tight" style={{fontFamily:'Gotham,sans-serif'}}>Servicios y Banners</p>
              <p className="text-[11px] text-[#58677A]/60">Home + /servicios-proyectos + /servicios/:slug</p>
            </div>
          </div>
          <button onClick={onLogout} className="inline-flex items-center gap-1.5 text-xs text-[#58677A] hover:text-red-600 px-3 py-1.5 rounded-md hover:bg-red-50" data-testid="admin-logout"><LogOut size={13}/> Salir</button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl sm:text-2xl font-black text-[#58677A]" style={{fontFamily:'Gotham,sans-serif'}}>Servicios ({items.length})</h1>
            <p className="text-xs text-[#58677A]/70 mt-0.5">Reordena, edita o agrega servicios. Cada uno controla: bloque Home, banner del hub y página de categoría.</p>
          </div>
          <button
            onClick={() => setShowCreate((v) => !v)}
            className="inline-flex items-center gap-1.5 bg-[#ED6B24] hover:bg-[#ff8242] text-white text-sm font-semibold rounded-lg px-4 py-2"
            data-testid="add-servicio-btn"
          ><Plus size={15}/> Nuevo servicio</button>
        </div>

        {showCreate && (
          <div className="bg-white rounded-2xl border border-[#58677A]/10 p-5" data-testid="create-servicio-panel">
            <h2 className="font-bold text-[#58677A] mb-3" style={{fontFamily:'Gotham,sans-serif'}}>Crear nuevo servicio</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <label className="text-xs text-[#58677A]/70 block mb-1">Nombre</label>
                <input value={newName} onChange={(e) => { setNewName(e.target.value); if (!newSlug) setNewSlug(e.target.value.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')); }} placeholder="ej. Publicidad Digital" className="w-full border border-[#58677A]/20 rounded-lg px-3 py-2 focus:outline-none focus:border-[#ED6B24]" data-testid="new-servicio-name"/>
              </div>
              <div>
                <label className="text-xs text-[#58677A]/70 block mb-1">Slug (URL: /servicios/…)</label>
                <input value={newSlug} onChange={(e) => setNewSlug(e.target.value)} placeholder="ej. publicidad-digital" className="w-full border border-[#58677A]/20 rounded-lg px-3 py-2 focus:outline-none focus:border-[#ED6B24] font-mono text-sm" data-testid="new-servicio-slug"/>
              </div>
            </div>
            <div className="mt-4 flex gap-2 justify-end">
              <button onClick={() => setShowCreate(false)} className="text-sm px-4 py-2 rounded-lg text-[#58677A] hover:bg-[#58677A]/10">Cancelar</button>
              <button onClick={create} disabled={creating} className="text-sm px-4 py-2 rounded-lg bg-[#ED6B24] hover:bg-[#ff8242] text-white disabled:opacity-60" data-testid="create-servicio-confirm">{creating ? 'Creando…' : 'Crear y editar'}</button>
            </div>
          </div>
        )}

        <section className="bg-white rounded-2xl border border-[#58677A]/10">
          {loading && <div className="p-8 text-center text-[#58677A]/60"><Loader2 className="mx-auto animate-spin mb-2"/>Cargando…</div>}
          {!loading && (
            <ul className="divide-y divide-[#58677A]/10">
              {items.map((s, i) => (
                <li key={s.id} className="flex items-center gap-4 px-5 py-4" data-testid={`servicio-row-${s.slug}`}>
                  <div className="flex flex-col gap-0.5 text-[#58677A]/50"><GripVertical size={14}/></div>
                  <div className="flex flex-col gap-1">
                    <button onClick={() => move(i, -1)} disabled={i===0} className="w-7 h-7 rounded flex items-center justify-center text-[#58677A] hover:bg-[#ED6B24]/10 disabled:opacity-30" title="Subir" data-testid={`up-${s.slug}`}><ArrowUp size={14}/></button>
                    <button onClick={() => move(i, 1)} disabled={i===items.length-1} className="w-7 h-7 rounded flex items-center justify-center text-[#58677A] hover:bg-[#ED6B24]/10 disabled:opacity-30" title="Bajar" data-testid={`down-${s.slug}`}><ArrowDown size={14}/></button>
                  </div>
                  <div className="w-24 h-14 rounded-lg overflow-hidden bg-[#f4f5f7] flex-shrink-0 border border-[#58677A]/10">
                    {s.hubBanner ? <img src={toUrl(s.hubBanner)} alt="" className="w-full h-full object-cover"/> : <div className="w-full h-full flex items-center justify-center text-[10px] text-[#58677A]/40">Sin banner</div>}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#58677A] truncate" style={{fontFamily:'Gotham,sans-serif'}}>{s.name}</p>
                    <p className="text-[11px] text-[#58677A]/60 font-mono">/servicios/{s.slug}</p>
                  </div>
                  <Link to={`/admin/servicios/${s.id}`} className="inline-flex items-center gap-1.5 bg-[#ED6B24]/10 hover:bg-[#ED6B24] hover:text-white text-[#ED6B24] text-xs font-semibold rounded-md px-3 py-1.5" data-testid={`edit-${s.slug}`}><Edit3 size={12}/> Editar</Link>
                  <button onClick={() => del(s)} className="text-red-500 hover:bg-red-50 w-8 h-8 rounded flex items-center justify-center" title="Eliminar" data-testid={`delete-${s.slug}`}><Trash2 size={14}/></button>
                </li>
              ))}
            </ul>
          )}
        </section>
      </main>
    </div>
  );
}
